import UnicomNoticeBar from './UnicomNoticeBar/index.vue'
import UnicomBlankPage from './UnicomBlankPage/index.vue'

const components = [
  UnicomNoticeBar,
  UnicomBlankPage
]

components.forEach(item => {
  item.install = (Vue) => {
    Vue.component(item.name, item)
  }
})

const commonModule = (Vue) => {
  components.forEach(component => {
    Vue.use(component)
  })
}

export {
  commonModule
}
